import { render } from "./dialog-paciente-view.vue?vue&type=template&id=77a04d24&scoped=true"
import script from "./dialog-paciente-view.vue?vue&type=script&lang=js"
export * from "./dialog-paciente-view.vue?vue&type=script&lang=js"

import "./dialog-paciente-view.vue?vue&type=style&index=0&id=77a04d24&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer1/WorkSpaceFront/ser-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a04d24"]])

export default __exports__